/// <amd-module name="SuiteCommerce.Blog.Shopping"/>
define("SuiteCommerce.Blog.Shopping", ["require", "exports", "SuiteCommerce.Blog.Post", "SuiteCommerce.Blog.BlogHome", "SuiteCommerce.Blog.DataProvider", "SuiteCommerce.Blog.Common.Configuration", "Handlebars", "SuiteCommerce.Blog.Common.Instrumentation.Helper", "SuiteCommerce.Blog.PostCardsCCT"], function (require, exports, Post, Blog, DataProvider_1, Configuration_1, Handlebars, Instrumentation_Helper_1, PostCardsCCT) {
    "use strict";
    return {
        mountToApp: function (container) {
            var environment = container.getComponent('Environment');
            this.initializeConfiguration(environment);
            this.initializeInstrumentation(environment);
            this.registerHandlebarsHelpers();
            DataProvider_1.DataProvider.fetchEntitiesData();
            Post.mountToApp(container);
            Blog.mountToApp(container);
            PostCardsCCT.mountToApp(container);
        },
        initializeConfiguration: function (environment) {
            Configuration_1.Configuration.environment = environment;
        },
        initializeInstrumentation: function (environment) {
            Instrumentation_Helper_1.InstrumentationHelper.initializeInstrumentation(environment);
        },
        registerHandlebarsHelpers: function () {
            Handlebars.registerHelper('sc_ext_when', function (value1, operator, value2, options) {
                var supportedOperations = {
                    '===': function (member1, member2) {
                        return member1 === member2;
                    },
                    '!==': function (member1, member2) {
                        return member1 !== member2;
                    },
                    '>': function (member1, member2) {
                        return Number(member1) > Number(member2);
                    },
                    '<': function (member1, member2) {
                        return Number(member1) < Number(member2);
                    },
                    '>=': function (member1, member2) {
                        return Number(member1) >= Number(member2);
                    },
                    '<=': function (member1, member2) {
                        return Number(member1) <= Number(member2);
                    },
                    '&&': function (member1, member2) {
                        return member1 && member2;
                    },
                    '||': function (member1, member2) {
                        return member1 || member2;
                    },
                };
                var result = supportedOperations[operator](value1, value2);
                return result
                    ? options.fn
                        ? options.fn(this)
                        : result
                    : options.inverse
                        ? options.inverse(this)
                        : result;
            });
        },
    };
});
